document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tt-product]').forEach(root => {
    const mainImage = root.querySelector('[data-tt-main-image]');
    const galleryThumbs = [...root.querySelectorAll('[data-tt-thumb]')];
    let galleryIndex = Math.max(0, galleryThumbs.findIndex(thumb => thumb.classList.contains('active')));
    let galleryRequest = 0;
    const showGalleryImage = index => {
      if (!galleryThumbs.length || !mainImage) return;
      const nextIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      const thumb = galleryThumbs[nextIndex];
      if (!thumb?.dataset.image) return;
      const request = ++galleryRequest;
      const preload = new Image();
      preload.onload = () => {
        if (request !== galleryRequest) return;
        galleryIndex = nextIndex;
        galleryThumbs.forEach(item => item.classList.remove('active', 'is-active'));
        thumb.classList.add('active', 'is-active');
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = thumb.dataset.image;
      };
      preload.src = thumb.dataset.image;
    };
    galleryThumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        if (!mainImage || !thumb.dataset.image) return;
        showGalleryImage(index);
      });
    });
    root.querySelector('[data-tt-gallery-prev]')?.addEventListener('click', () => showGalleryImage(galleryIndex - 1));
    root.querySelector('[data-tt-gallery-next]')?.addEventListener('click', () => showGalleryImage(galleryIndex + 1));

    const price = root.querySelector('[data-tt-price]');
    const comparePrice = root.querySelector('[data-tt-compare-price]');
    root.querySelectorAll('[data-tt-pack]').forEach(pack => {
      pack.addEventListener('change', () => {
        if (price && pack.dataset.price) price.textContent = pack.dataset.price;
        if (comparePrice) {
          comparePrice.textContent = pack.dataset.comparePrice || '';
          comparePrice.hidden = !pack.dataset.comparePrice;
        }
        root.querySelectorAll('.offer-option').forEach(option => option.classList.remove('active'));
        pack.closest('.offer-option')?.classList.add('active');
      });
    });

    const buildSizeInputs = [...root.querySelectorAll('[data-tt-build-size]')];
    const buildSlots = [...root.querySelectorAll('[data-tt-build-slot]')];
    const buildCount = root.querySelector('[data-tt-build-count]');
    const buildSubmit = root.querySelector('[data-tt-build-submit]');

    if (buildSizeInputs.length && buildSlots.length && buildCount && buildSubmit) {
      const updateBuildPreview = select => {
        const preview = select.closest('[data-tt-build-slot]')?.querySelector('[data-tt-build-preview]');
        const selectedOption = select.selectedOptions[0];
        if (preview && selectedOption?.dataset.image) preview.src = selectedOption.dataset.image;
      };

      const updateBuildBundle = () => {
        const selectedSize = root.querySelector('[data-tt-build-size]:checked');
        const target = Number(selectedSize?.dataset.ttBuildSize || 0);
        buildSlots.forEach((slot, index) => {
          const isActive = index < target;
          const select = slot.querySelector('[data-tt-build-select]');
          slot.hidden = !isActive;
          if (select) select.disabled = !isActive;
        });
        buildCount.textContent = `${target} plaques configurées`;
        buildSubmit.disabled = target === 0;
      };

      buildSlots.forEach(slot => {
        const select = slot.querySelector('[data-tt-build-select]');
        select?.addEventListener('change', () => updateBuildPreview(select));
      });

      buildSizeInputs.forEach(input => {
        input.addEventListener('change', updateBuildBundle);
      });

      updateBuildBundle();
    }

    const variantSelect = root.querySelector('[data-tt-variant]');
    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });

    const productForm = root.querySelector('.tt-premium-product-form');
    productForm?.addEventListener('submit', async event => {
      const fileInput = productForm.querySelector('input[type="file"]');
      if (fileInput?.files?.length) return;
      event.preventDefault();
      const submit = productForm.querySelector('[type="submit"]');
      const original = submit?.innerHTML;
      if (submit) { submit.disabled = true; submit.textContent = 'AJOUT…'; }
      try {
        const formData = new FormData(productForm);
        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = String(value);
        }
        await window.TrustTapAddItems([{
          id:Number(formData.get('id')),
          quantity:Number(formData.get('quantity') || 1),
          properties
        }]);
        await window.TrustTapCart?.open();
      } catch (error) {
        window.alert(error.message || 'Impossible d’ajouter ce produit au panier.');
      } finally {
        if (submit) { submit.disabled = false; submit.innerHTML = original; }
      }
    });

    root.querySelectorAll('[data-tt-quick-add]').forEach(button => {
      button.addEventListener('click', async () => {
        const original = button.textContent;
        button.disabled = true;
        button.textContent = 'Ajout…';
        try {
          await window.TrustTapAddItems([{id:Number(button.dataset.ttQuickAdd),quantity:1,properties:{'Offre TrustTap':'Prix promotionnel déjà appliqué'}}]);
          button.textContent = 'Ajouté ✓';
          window.setTimeout(() => document.querySelector('[data-site-cart-open]')?.click(), 250);
        } catch (error) {
          button.textContent = 'Réessayer';
        } finally {
          window.setTimeout(() => { button.disabled = false; button.textContent = original; }, 1800);
        }
      });
    });
  });
});
